import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'

export const updateEmailDomainsMutation = gql`
  mutation UpdateEmailDomains($organizationID: ID!, $domains: String!) {
    updateEmailDomains(
      input: { organizationID: $organizationID, domains: $domains }
    ) {
      _placeholder
    }
  }
`

export interface UpdateEmailDomainsArgs {
  readonly organizationID: string
  readonly domains: string
}

export function UpdateEmailDomainsMutation({
  children
}: {
  readonly children: (
    updateEmailDomains: (variables: UpdateEmailDomainsArgs) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, UpdateEmailDomainsArgs> mutation={updateEmailDomainsMutation}>
      {(updateEmailDomains) =>
        children(async (variables: UpdateEmailDomainsArgs) => {
          await updateEmailDomains({ variables })
        })
      }
    </Mutation>
  )
}
